export default __webpack_public_path__ + "2d3c48694051bc78fa9df3849218fc5c.svg";